import { useMutation } from "react-query";
import { storeOnboarding } from "../../../../../services/vmApi";

export function useCreateOnboarding(options) {
  return useMutation(
    (data) => storeOnboarding(data),
    options
  );
}
